import { atom, useAtomValue } from 'jotai'
import type { DiscountCoupon } from '~/lib/graphql/graphql'
import type { DiscountCouponCode } from '~/lib/graphql/scalars'
import {
  appliedDiscountCoupon$,
  discountCouponType$,
  useAppliedDiscountCoupon,
} from '../../store/stateMachine/context'
import type { SelectedDiscountCouponType } from '../../store/stateMachine/statemachine'

export function useAppliedMessage() {
  const appliedCoupon = useAppliedDiscountCoupon()
  const applied = useIsAppliedDiscountCoupon()
  return { appliedCoupon, applied }
}

const isAppliedDiscountCoupon$ = atom((get) => {
  const appliedCoupon = get(appliedDiscountCoupon$)
  const couponType = get(discountCouponType$)
  return isAppliedDiscountCoupon({ couponType, appliedCoupon })
})
isAppliedDiscountCoupon$.debugLabel = 'isAppliedDiscountCoupon$'

export function useIsAppliedDiscountCoupon() {
  return useAtomValue(isAppliedDiscountCoupon$)
}

function isAppliedDiscountCoupon(data: {
  couponType?: SelectedDiscountCouponType
  appliedCoupon?: DiscountCoupon
}) {
  return data.couponType?.type === 'InputtedCouponCode' && data.appliedCoupon !== undefined
}
if (import.meta.vitest) {
  const { it, expect } = import.meta.vitest
  it('isAppliedDiscountCoupon', async () => {
    expect(
      isAppliedDiscountCoupon({
        couponType: {
          type: 'AcquiredCoupon',
          code: '1234567890' as DiscountCouponCode,
        } as SelectedDiscountCouponType,
        appliedCoupon: {
          code: '1234567890',
        } as DiscountCoupon,
      })
    ).toBe(false)
    expect(
      isAppliedDiscountCoupon({
        couponType: { type: 'InputtedCouponCode' },
        appliedCoupon: {
          code: '1234567890',
        } as DiscountCoupon,
      })
    ).toBe(true)
    expect(
      isAppliedDiscountCoupon({
        couponType: {
          type: 'AcquiredCoupon',
          code: '1234567890' as DiscountCouponCode,
        },
      })
    ).toBe(false)
  })
}
